

import { Route, Routes } from 'react-router-dom';
import { Footer } from './layouts/Footer';
import Header from './layouts/Header';
import LandingPage from './pages/Landing Page';
import AboutUs from './pages/AboutUs';
import Capabilities from './pages/Capabilities';
import Products from './pages/Products';
import CaseStudy from './components/Case Study/CaseStudy';
import { useContext } from 'react';
import { DContext } from './context/DataContext';
import ContactForm from './pages/Form';
import ScrollTop from './components/ScrollTop';
import Corporate from './pages/Corporate';
import Services from './pages/Services';

function App() {
  const { openForm, setOpenForm } = useContext(DContext)
  return (
    <div className=' '>
      <ScrollTop />
      <Header />
      {/* <LandingPage /> */}

      <Routes>
        <Route path='/' element={<LandingPage />} />
        <Route path='/about' element={<AboutUs />} />
        <Route path='/capable' element={<Capabilities />} />
        <Route path='/product' element={<Products />} />
        <Route path='/product/:name' element={<CaseStudy />} />
        <Route path='/Corporate' element={<Corporate />} />
        <Route path='/services' element={<Services />} />



      </Routes>
      {openForm && (
        <ContactForm onClose={() => setOpenForm(false)} />
      )}
      <Footer />


    </div>
  );
}


export default App;
